export default __webpack_public_path__ + "static/media/Thumb_Accessories_04.8d202ade.png";